module.exports = __webpack_public_path__ + "97740a044a04c2b021461d650c2d972d.pdf";